import { Avatar, type AvatarProps } from '@mantine/core';
import type { LightUser } from 'shared/hooks/use-load-light-users';

type UserAvatarProps = AvatarProps & {
  user: LightUser;
};

export const UserAvatar = ({ user, ...props }: UserAvatarProps) => {
  if (user.profilePicture != null) {
    return <Avatar src={user.profilePicture} alt={user.name.full} {...props} />;
  }

  return <Avatar {...props}>{user.name.initials}</Avatar>;
};
